'use client';

import { Color } from '@diritto/common/style/color';
import styled from '@emotion/styled';
import { ButtonType } from 'constants/button';
import { ModalParams, ModalType } from 'constants/modal';
import Link from 'next/link';
import { useCallback, useEffect, useState } from 'react';
import { Button } from 'ui-components/common/Button';
import { ModalLayout } from 'ui-components/layout/ModalLayout';
import { useShowModal } from 'ui-hooks/useShowModal';
import { ModalHandler } from 'utils/ModalHandler';

export const PromotionNotEligibleModal = () => {
  const { isShow, revealModal, showModal, hideModal } = useShowModal();
  const [state, setState] = useState<ModalParams[ModalType.PromotionNotEligible]>();

  const handleHide = useCallback(() => {
    hideModal();
  }, [hideModal]);

  const handleClose = useCallback(() => {
    state?.onCancel?.();
    handleHide();
  }, [handleHide, state]);

  useEffect(() => {
    const listener = (show: boolean, params?: ModalParams[ModalType.PromotionNotEligible]) => {
      setState(params);

      if (show) {
        showModal();
      } else {
        handleHide();
      }
    };

    ModalHandler.addEventListener(ModalType.PromotionNotEligible, listener);

    return () => {
      ModalHandler.removeEventListener(ModalType.PromotionNotEligible);
    };
  }, [handleHide, showModal]);

  return (
    <ModalLayout isShow={isShow} revealModal={revealModal} isBottom={false}>
      <StyledModal>
        <StyledBody>
          <div
            style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: 16,
              display: 'inline-flex',
            }}>
            <div
              style={{
                alignSelf: 'stretch',
                color: 'black',
                fontSize: 18,
                fontWeight: '700',
                wordWrap: 'break-word',
              }}>
              이벤트 참여 조건을 확인해주세요.
            </div>
            <div
              style={{
                color: '#57606A',
                fontSize: 14,
                fontWeight: '500',
                lineHeight: '21px',
                wordWrap: 'break-word',
              }}>
              이벤트에 참여하려면 필수 조건 3가지를 확인 후 완료해주세요.
            </div>
          </div>
          <StyledButtons>
            <div>
              <StyledButton label="닫기" buttonType={ButtonType.SecondaryNoBorder} onClick={handleClose} />
            </div>
            <Link
              href="/promotions/2024-santa-ritto#todo"
              role="button"
              tabIndex={-1}
              style={{
                width: '140px',
                height: '40px',
                paddingLeft: 20,
                paddingRight: 20,
                paddingTop: 11,
                paddingBottom: 11,
                background: '#915FFF',
                borderRadius: 4,
                border: '1px #915FFF solid',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 4,
                display: 'inline-flex',
                cursor: 'pointer',
                alignSelf: 'flex-end',
              }}
              onClick={hideModal}
              onKeyUp={hideModal}>
              <div
                role="button"
                tabIndex={-1}
                style={{
                  textAlign: 'center',
                  color: 'white',
                  fontSize: 12,
                  fontFamily: 'Pretendard',
                  fontWeight: '700',
                  lineHeight: 18,
                  wordWrap: 'break-word',
                }}>
                조건 완료하러 가기
              </div>
            </Link>
          </StyledButtons>
        </StyledBody>
      </StyledModal>
    </ModalLayout>
  );
};

const StyledModal = styled.div`
  width: 100vw;
  border-radius: 4px 4px 0 0;
  width: 320px;
  border-radius: 4px;
  background-color: ${Color.White};

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  width: 100%;
  height: 40px;
`;

const StyledButton = styled(Button)`
  width: 100%;
`;

const StyledBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;
